import { useState, useEffect } from "react";
import "./guide.css";

export default function Guide() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email.includes("@")) {
      setError("Please enter a valid email.");
      return;
    }

    try {
      setLoading(true);

      // Save email + fetch guide content
      const res = await fetch("/api/guide", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      setContent(data.content);
      setSubmitted(true);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="big-tech-guide">
        <h5>How I got 9 Software Engineer Offers from FAANG+</h5>
        <h2>The Complete Guide to Big Tech</h2>
        <div className="guide-page">
        {!submitted ? (
            <div className="email-gate">
            <h1>The Complete Guide to Big Tech</h1>
            <p>
                How I went from English Major to Computer Science, to 9 Big Tech offers from Meta, Apple, Amazon, Microsoft, Notion, and more
            </p>

            <form onSubmit={handleSubmit}>
                <input
                type="email"
                placeholder="Enter your email to unlock"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                />
                <button type="submit" disabled={loading}>
                {loading ? "Unlocking..." : "Unlock the Guide"}
                </button>
            </form>

            {error && <span className="error">{error}</span>}

            <span className="privacy">
                No spam. No fluff. Unsubscribe anytime.
            </span>
            </div>
        ) : (
            <div className="guide-content">
            {/* DOCX converted HTML injected here */}
            <div
                className="content"
                dangerouslySetInnerHTML={{ __html: content }}
            />
            </div>
        )}
        </div>
    </section>
  );
}
